module.exports = __webpack_public_path__ + "img/InCopyright.7e5a59fc.png";